export function pageLoader() {
//   function fadeOut(){
//     jQuery(".loader-screen").addClass("fadeOutLoader");
//   }
//   var ignore_onbeforeunload = false;
//     jQuery('a[href^=mailto]').on('click',function(){
//         ignore_onbeforeunload = true;
// 	});
// 	jQuery('a[href^=tel]').on('click',function(){
//         ignore_onbeforeunload = true;
//     });
//   setTimeout(fadeOut, 100);
// 	window.onbeforeunload = function () {
// 		if (!ignore_onbeforeunload){
// 			jQuery(".loader-screen").removeClass("fadeOutLoader");
// 			jQuery(".loader-screen").addClass("fadeInLoader");
//         }
//         ignore_onbeforeunload = false;
// 	};

}

export default pageLoader;
